import { Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';

interface DisabledCardStateProps {
  disabledMessage: string;
  src: string;
  alt: string;
}

const DisabledCardState: React.FC<DisabledCardStateProps> = ({ disabledMessage, src, alt }) => {
  return (
    <div className="card-content-wrapper disabled">
      <Typography
        sx={{
          textAlign: 'center',
          marginTop: '20px',
          fontSize: '16px',
          fontWeight: '400',
          color: grey[500],
        }}
        variant="h5"
        component="p"
        gutterBottom
      >
        {disabledMessage}
      </Typography>
      <img src={src} alt={alt} className="card-logo" style={{ filter: 'grayscale(1)', opacity: 0.4 }} />
    </div>
  );
};

export default DisabledCardState;
